import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { toast } from 'sonner';
import { accountsNewService } from '../services/accountsNew.service';
import type { AccountRecord } from '../../list/types/accounts.types';

export function useAccountsNew() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  
  const [formData, setFormData] = useState({
    accountName: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    accountHolder: '',
    currency: 'VND',
    initialBalance: 0,
    status: 'active' as const,
    isDefault: false,
    description: '',
  });

  const mutation = useMutation({
    mutationFn: (data: any) => accountsNewService.createAccount({
      ...data,
      companyId: profile?.company_id,
      createdBy: profile?.id,
    }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'accounts'] });
      toast.success('Đã thêm tài khoản mới');
      navigate('?tab=account');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Không thể thêm tài khoản');
    }
  });

  return {
    formData,
    setFormData,
    isSaving: mutation.isPending,
    createAccount: () => mutation.mutate(formData),
  };
}
